import { useEffect, useState } from 'react'

const isTabActive = () => document.hasFocus() && !document.hidden

export default function useIsTabActive() {
  const [active, setActive] = useState(isTabActive)

  useEffect(() => {
    const update = () => setActive(isTabActive())

    document.addEventListener('visibilitychange', update)
    window.addEventListener('focus', update)
    window.addEventListener('blur', update)

    return () => {
      document.removeEventListener('visibilitychange', update)
      window.removeEventListener('focus', update)
      window.removeEventListener('blur', update)
    }
  }, [])

  return active
}
